module.exports = __webpack_public_path__ + "img/logo.0c9bfe8f.png";